<style scoped>
  .initModal {
    padding: 0 12px;
    text-align: center;
  }
  #findpasswordcontent{
    margin:0 auto;
    text-align: center;
    width: 500px;
  }
  .img-yzm{ width:100px;height:34px;margin: 1px;vertical-align: middle;}
</style>
<template>
  <div>
      <div id="findpasswordcontent" width="400">
        <div>
          <Tabs value="phoneFindPassport" :animated="false" @on-click="changeTabs">
            <TabPane label="手机找回" name="phoneFindPassport">
              <Form ref="phoneFormParams" :model="phoneFormParams" :rules="phoneRuleValidate" class="initModal">
                <FormItem prop="mobile">
                  <Input v-model.trim="phoneFormParams.mobile" placeholder="手机号码" style="width:323px;" :maxlength="11" @on-blur="phoneValid"></Input>
                </FormItem>
                <FormItem prop="checkCode">
                    <Input v-model.trim="phoneFormParams.checkCode" placeholder="验证码" style="width:152px;left:4px;vertical-align: middle;" ></Input>
                    <img id="checkCodeImg1" alt="验证码"  src="../../../theme/ocean/images/captcha.jpg" class="img-yzm"/>
                    <Button type="default"  @click="getNewCheckCode" style="background-color: #ececec;padding:8px 16px;width:70px;vertical-align: middle;">换一张</Button>
                </FormItem>
                <FormItem>
                  <Row>
                    <Col span="15">
                      <FormItem prop="mobileCode">
                        <Input v-model.trim="phoneFormParams.mobileCode" placeholder="手机验证码" style="width:152px; position:relative; left:4px;" @on-blur="phoneCodeValid"></Input>
                      </FormItem>
                    </Col>
                    <Col span="2">
                      <FormItem>
                        <Button type="default" :disabled="disabledMobile || mobileTime > 0" @click="sendMobileCode" style="background-color: #ececec;padding:8px 16px;width:102px;">{{ mobileText }}</Button>
                      </FormItem>
                    </Col>
                  </Row>
                </FormItem>
                <FormItem prop="password">
                  <Input v-model.trim="phoneFormParams.password" type="password" placeholder="密码长度应介于6~16位之间" style="width:323px;"></Input>
                </FormItem>
                <FormItem prop="confirmPassword">
                  <Input v-model.trim="phoneFormParams.confirmPassword" type="password" placeholder="再次确认密码" style="width:323px;"></Input>
                </FormItem>
              </Form>
            </TabPane>
            <TabPane label="邮箱找回" name="emailFindPassport">
              <Form ref="emailFormParams" :model="emailFormParams" :rules="emailRuleValidate" class="initModal">
                <FormItem prop="email">
                  <Input v-model.trim="emailFormParams.email" placeholder="邮箱地址" style="width:323px;" @on-blur="emailValid"></Input>
                </FormItem>
                <FormItem prop="checkCode">
                    <Input v-model.trim="emailFormParams.checkCode" placeholder="验证码" style="width:152px;left:4px;vertical-align: middle;" ></Input>
                    <img id="checkCodeImg2" alt="验证码"  src="../../../theme/ocean/images/captcha.jpg" class="img-yzm"/>
                    <Button type="default"  @click="getNewCheckCode" style="background-color: #ececec;padding:8px 16px;width:70px;vertical-align: middle;">换一张</Button>
                </FormItem>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div style="padding:0 39px;">
          <Button type="primary" size="large" long @click="submitBtn">提交</Button>
        </div>
    </div>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
export default {
  mixins: [ Mixin, tableMixin],
  components: {},
  data () {
    let self = this;
    return {
      phoneFormParams: {
        mobile: '', // 手机号码
        mobileCode: '', // 手机验证码
        checkCode:'',// 验证码
        password: '', // 密码
        confirmPassword: '' // 确认密码
      },
      phoneRuleValidate: {
        mobile: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          { validator: self.validateMobile(), trigger: 'blur' } // 手机号码校验
        ],
        checkCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ],
        mobileCode: [
          { required: true, message: '手机验证码不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: self.validatePassword(), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次确认密码', trigger: 'blur' },
          { validator: self.validateMobileConfirmPwd(), trigger: 'blur' }
        ]
      },
      emailFormParams: {
        email: '', // 邮箱
        checkCode:'',// 验证码
      },
      emailRuleValidate: {
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        checkCode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      phoneOrEmailFlag: 'phoneFindPassport',
      disabledMobile: false,
      mobileTime: 0, // 获取手机验证码初始0
    };
  },
  methods: {
    Login () {
      let origin = window.location.origin;
      let url = origin + '/logisicsProvider.html#/';
      window.location.href = url;
    },
    getNewCheckCode() {
        let v = this;
        var time = new Date().getTime();//为了防止缓存导致不能正常刷新验证码
        if (v.phoneOrEmailFlag == 'phoneFindPassport') {
            document.getElementById("checkCodeImg1").src = "/common/getCaptcha?d="+time;
        } else if (v.phoneOrEmailFlag === 'emailFindPassport') {
            document.getElementById("checkCodeImg2").src = "/common/getCaptcha?d="+time;
        }
    },
    phoneValid (callback) {
      let v = this;
      if (v.phoneFormParams.mobile !== '') {
          var obj = {
              mobile:v.phoneFormParams.mobile
          };
        v.axios.post(api.userIsExist ,obj)
          .then(res => {
            if (res.data.code === 0) {
              if (callback && typeof callback === 'function') {
                callback();
              }
            } else if (res.data.code === 30003) {
              v.$Message.error('当前手机号码账号已存在');
            }
          });
      }
    },
    phoneCodeValid () {
      let v = this;
      if (v.phoneFormParams.mobileCode !== '') {
          var obj = {
              mobileNo:v.phoneFormParams.mobile,
              mobileCode:v.phoneFormParams.mobileCode,
              msgType:'2'
          };
        v.axios.post(api.checkMobileCode ,obj)
          .then(res => {
            if (res.data.code === 30004) {
              v.$Message.error('手机验证码输入错误，请重新输入');
            }
          });
      }
    },
    emailValid (callback) {
      let v = this;
      if (v.emailFormParams.email !== '') {
          var obj = {
              email : v.emailFormParams.email
          };
        v.axios.post(api.userIsExist,obj)
          .then(res => {
            if (res.data.code === 0) {
              callback && callback();
            } else if (res.data.code === 30002) {
              v.$Message.error('当前邮箱账号已存在');
            }
          });
      }
    },
    // 手机号码校验
    validateMobile () {
      let validateMobile = function (rule, value, callback) {
        if (value.length !== 11 && value !== '') {
          callback(new Error('手机号码格式不正确'));
        } else {
          callback();
        }
      };
      return validateMobile;
    },
    // 密码格式校验
    validatePassword () {
      let validatePassword = function (rule, value, callback) {
        if (value.length < 6 || value.length > 16) {
          callback(new Error('密码长度应介于6~16位之间'));
        } else {
          callback();
        }
      };
      return validatePassword;
    },
    validateMobileConfirmPwd () {
      let v = this;
      let validateMobileConfirmPwd = function (rule, value, callback) {
        if (value !== v.phoneFormParams.password) {
          callback(new Error('确认密码和密码不一致'));
        } else {
          callback();
        }
      };
      return validateMobileConfirmPwd;
    },
    // 启动手机验证码倒计时
    startMobileCountdown () {
      let v = this;
      v.mobileTime = 60;
      v.mobileTimer();
    },
    // 获取手机验证码定时器
    mobileTimer () {
      let v = this;
      if (v.mobileTime > 0) {
        v.mobileTime--;
        setTimeout(v.mobileTimer, 1000);
      }
    },
    // 发送手机验证码
    sendMobileCode () {
      let v = this;
      if (v.phoneFormParams.mobile === '') {
        v.$Message.error('请输入手机号码');
      } else if (v.phoneFormParams.mobile.length !== 11 && v.phoneFormParams.mobile !== '') {
        v.$Message.error('手机号码格式不正确');
      } else {
        v.phoneValid(() => {
          v.startMobileCountdown(); // 启用手机验证码倒计时
          var param = {
            mobileNo:v.phoneFormParams.mobile,
            msgType:'2'
          };
          v.axios.post(api.sendMobileCode ,param)
            .then(res => {
              if (res.data.code === 0) {
                v.$Message.success('验证码已经发送到你的手机');
              }
            });
        });
      }
    },
    // 点击切换Tabs
    changeTabs (name) {
      let v = this;
      if (name === 'phoneFindPassport') {
        return v.phoneOrEmailFlag = 'phoneFindPassport';
      } else if (name === 'emailFindPassport') {
        return v.phoneOrEmailFlag = 'emailFindPassport';
      }
    },
    // 手机号码或者邮箱是否已经注册
    userIsExistFn () {
      let v = this;
      let isExistValid = true;
      if (v.phoneOrEmailFlag === 'phoneFindPassport') {
        var obj = {
            mobile: v.phoneFormParams.mobile
        };
        v.axios.post(api.userIsExist ,obj)
          .then(res => {
            if (res.data.code === 0) {
            }else if (res.data.code === 30003) {
              v.$Message.error('当前手机号码注册失败，该账号已存在');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
          var param = {
              mobileNo:v.phoneFormParams.mobile,
              mobileCode:v.phoneFormParams.mobileCode,
              msgType:'2'
          };
        v.axios.post(api.checkMobileCode, param)
          .then(res => {
            if (res.data.code === 0) {
            }else if (res.data.code === 30004) {
              v.$Message.error('手机验证码输入错误，请重新输入');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
               isExistValid = false;
            }
          });
      } else if (v.phoneOrEmailFlag === 'emailFindPassport') {
          var obj = {
            email: v.emailFormParams.email
        };
        v.axios.post(api.userIsExist,email)
          .then(res => {
            if (res.data.code === 0) {
            }else if (res.data.code === 30002) {
              v.$Message.error('当前邮箱注册失败，该账号已存在');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
               isExistValid = false;
            }
          });
          var param = {
              email:v.emailFormParams.email,
              emailCode:v.emailFormParams.emailCode,
              msgType:'2'
          };
        v.axios.post(api.checkEmailCode ,param)
          .then(res => {
            if (res.data.code === 0) {
            }else if (res.data.code === 30007) {
              v.$Message.error('邮箱验证码输入错误，请重新输入');
              isExistValid = false;
            } else {
              v.$Message.error(res.data.message);
              isExistValid = false;
            }
          });
      }
      return isExistValid;
    },
    // 立即注册
    submitBtn () {
      let v = this;
      if (v.phoneOrEmailFlag === 'phoneFindPassport') {
        var mobileObj = {
          mobileNo: v.phoneFormParams.mobile, // 手机号码
          password: v.phoneFormParams.password, // 密码
          checkCode: v.phoneFormParams.checkCode, // 验证码
          mobileCode:v.phoneFormParams.mobileCode,// 手机验证码
          msgType: '2',
          registerType: 'mobile'
        };
        v.$refs['phoneFormParams'].validate((valid) => {
          if (valid) {
            if (v.userIsExistFn()) {
              v.axios.post(api.findPassword, mobileObj)
                .then(res => {
                  if (res.data.code === 0) {
                    v.$Message.success('提交成功');
                    v.Login();
                  } else if (res.data.code === 30004) {
                    v.$Message.error('手机验证码输入错误，请重新输入');
                  } else {
                    v.$Message.error(res.data.message);
                  }
                });
            }
          } else {
            v.$Message.error('请填写必填项');
          }
        });
      } else if (v.phoneOrEmailFlag === 'emailFindPassport') {
        var emailObj = {
          email: v.emailFormParams.email, // 邮箱地址
          checkCode: v.emailFormParams.checkCode, // 验证码
          msgType: '2',
          registerType: 'email'
        };
        v.$refs['emailFormParams'].validate((valid) => {
          if (valid) {
            if (v.userIsExistFn()) {
              v.axios.post(api.findPassword, emailObj)
                .then(res => {
                  if (res.data.code === 0) {
                    v.$Message.success('提交成功');
                    v.Login();
                  } else {
                    v.$Message.error(res.data.message);
                  }
                });
            }
          } else {
            v.$Message.error('请填写必填项');
          }
        });
      }
    }
  },
  computed: {
    mobileText: function () {
      return this.mobileTime > 0 ? this.mobileTime + 's再获取' : '获取验证码';
    }
  },
  watch: {
  }
};
</script>



// WEBPACK FOOTER //
// src/views/index/components/findpassword.vue